__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/2732cd596e3fba57c473542166a4732078a651146088b1baf09582b4/";